import { Place } from '../components/gmaps/place-selector.component'
import { GoogleMapsResults } from './gmaps.types'

export const GMAPS_API_KEY = 'AIzaSyDpadvQan2Y0hFoJF6iW_jV4N9Gmd9jqNo'

export const getGeocode = async (address: string): Promise<GoogleMapsResults> => {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${GMAPS_API_KEY}`
  const response = await fetch(url)
  const data = await response.json()
  return data
}

export const validateAddress = (place: Place): string[] => {
  const errors: string[] = []
  // must has street number
  const streetNumber = place.address_components?.find((component) => component.types.includes('street_number'))
  if (streetNumber == null) {
    errors.push('La dirección debe tener un número de calle')
  }

  // must has route
  const route = place.address_components?.find((component) => component.types.includes('route'))
  if (route == null) {
    errors.push('La dirección debe tener una calle')
  }

  // must has locality
  const locality = place.address_components?.find((component) => component.types.includes('locality'))
  if (locality == null) {
    errors.push('La dirección debe tener una localidad')
  }

  // must has administrative_area_level_1
  const administrativeArea = place.address_components?.find((component) => component.types.includes('administrative_area_level_1'))

  if (administrativeArea == null) {
    errors.push('La dirección debe tener una provincia')
  }

  return errors
}
